/**
 * 文档头部（XML 声明 / DOCTYPE / 根外注释）—— DOMParser + XMLSerializer 不保证保留它们，
 * 所以在打开时用正则单独截存，导出时原样还原。
 */
export interface Header {
  xmlDecl?: string;
  doctype?: string;
  leadingComments: string[];
}

const EMPTY: Header = { leadingComments: [] };

export function extractHeader(text: string): Header {
  const xmlDecl = /<\?xml[^>]*\?>/.exec(text)?.[0];
  const doctype = /<!DOCTYPE[^>]*>/i.exec(text)?.[0];
  const rootIdx = text.search(/<svg[\s>/]/i);
  const head = rootIdx > 0 ? text.slice(0, rootIdx) : '';
  const leadingComments = Array.from(head.matchAll(/<!--[\s\S]*?-->/g), (m) => m[0]);
  if (!xmlDecl && !doctype && leadingComments.length === 0) return EMPTY;
  return { xmlDecl, doctype, leadingComments };
}

export const hasHeader = (h: Header): boolean =>
  Boolean(h.xmlDecl || h.doctype || h.leadingComments.length > 0);
